import type { SVGProps } from "react";
const SvgIconWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <circle cx={512} cy={740.85} r={50} />
    <path d="M871 431.85a24.93 24.93 0 0 1-17.68-7.32c-188.2-188.21-494.44-188.21-682.64 0a25 25 0 1 1-35.36-35.36 532.31 532.31 0 0 1 753.36 0A25 25 0 0 1 871 431.85M368.76 647.61a25 25 0 0 1-17.67-42.67 227.55 227.55 0 0 1 321.83 0 25 25 0 1 1-35.36 35.35c-69.24-69.23-181.89-69.23-251.12 0a24.93 24.93 0 0 1-17.68 7.32" />
    <path d="M260.88 539.73a25 25 0 0 1-17.68-42.68 379.86 379.86 0 0 1 537.6 0 25 25 0 1 1-35.36 35.36c-128.72-128.72-338.16-128.72-466.88 0a24.93 24.93 0 0 1-17.68 7.32" />
  </svg>
);
export default SvgIconWifi;
